import { RequestSearchPayload } from '@flight-results/entities/request-search.payload';
import { PassengerType } from '@shared/base-search-bar/entities/passenger-arrangement';
import { environment } from '@environment';
import { RecentSearchFlight } from '@recent-searches/entities/recent-search';
import { RecentSearchDataType } from '@design-system/components/molecules/recent-search/entities/recent-search.types';

export function saveSearchMapper(payload: RequestSearchPayload): RecentSearchFlight {
  const tripFrom = payload.Trips[0];
  const tripTo = payload.Trips.length > 1 ? payload.Trips[1] : null;
  const dateCreated = new Date();
  return {
    datatype: RecentSearchDataType.Flight,
    branch_code: payload?.RequestSettings?.BranchCode,
    countrycode: environment.countryInfo.iso_code,
    from: tripFrom.DeparturePoint,
    departuredate: tripFrom.DepartureDate,
    to: tripFrom.ArrivalPoint,
    arrivaldate: payload.Trips.length > 1 ? tripTo.DepartureDate : tripFrom.DepartureDate,
    created_at: dateCreated.toISOString(),
    class: tripFrom.CabinCode,
    baggage: tripFrom.BaggageIncluded,
    roundtrip: payload.Trips.length > 1,
    travellers: [
      { type: PassengerType.ADULTS, quantity: +payload.Adults },
      { type: PassengerType.CHILDREN, quantity: +payload.Children },
      { type: PassengerType.INFANTS, quantity: +payload.Infants }
    ]
  };
}
